/**
 * Markeer een Wasserij-order als "al opgehaald" zonder ophaalrit — voor kleden
 * die de chauffeur bij een aflevering heeft meegenomen en al in de wasserij
 * liggen. Zet WO -> 'Opgehaald', items -> 'Klaar voor Voorinspectie' en
 * onderdrukt het ophaalvoorstel + reminders.
 */

import { supabase } from './supabase';

async function authHeader(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface MarkPickedUpResult {
  ok: boolean;
  nieuweStatus?: string;
  werkOrderNummer?: string;
  itemsKlaarVoorVoorinspectie?: number;
  werkOrderLastModifiedDate?: string;
  error?: string;
  code?: string;
}

export type MarkPickedUpMode = 'chauffeur' | 'klant';

export async function markOrderPickedUp(args: {
  orderId: string;
  /** 'chauffeur' (default, -> Opgehaald) | 'klant' (-> Zelf gebracht). */
  mode?: MarkPickedUpMode;
  /** 'YYYY-MM-DD'. Leeg = vandaag (in Salesforce). */
  pickupDate?: string;
  notes?: string;
}): Promise<MarkPickedUpResult> {
  const headers = await authHeader();
  const res = await fetch('/api/orders/mark-picked-up', {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      orderId: args.orderId,
      mode: args.mode || undefined,
      pickupDate: args.pickupDate || undefined,
      notes: args.notes || undefined,
    }),
  });
  const data = (await res.json()) as MarkPickedUpResult;
  return { ...data, ok: res.ok && data.ok !== false };
}
